import {
  CategoryTypes,
  PoiCategories,
  PoiDisplayNames
} from '../constants/poiCategories';

export default {
  data() {
    return {
      activePoi: ['transport', 'health', 'education', 'outdoor', 'food', 'shopping', 'childcare'],
      activeVenue: null,
      categoryTypes: CategoryTypes,
      method: 'driving',
      mobileView: false,
      poi: null,
      poiCategories: PoiCategories,
      poiDisplayNames: PoiDisplayNames,
      poiList: null,
      routeInfo: null,
      selectedPoi: null,

    }
  },
  watch: {
    poi: function (val, oldval) {
      if (val) {
        this.$store.commit("setActivePoi", this.activePoi)
      }
    },

    routeInfo: function (val, oldval) {
      if (!val) {
        this.$store.commit("setActivePoi", this.activePoi)
      }
    }
  },
  mounted() {
    this.mobileView = window.innerWidth <= 600;
  },
  methods: {
    checkMutations() {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setPoi') {
          this.poi = state.amenityStore.poi;
        }
        if (mutation.type === 'setActiveVenue') {
          this.activeVenue = state.amenityStore.activeVenue
        }
        if (mutation.type === 'setRouteInfo') {
          this.routeInfo = state.amenityStore.routeInfo
        }
      })
    },

    changeMethod(method) {
      this.method = method
      this.$store.commit("setDirectionMethod", this.method);
    },

    setActivePoi(category) {
      console.log('category', category);
      let categoryName;
      if (category.displayName === this.selectedPoi) {
        this.activePoi = this.categoryTypes;
        this.selectedPoi = this.categoryTypes;
      } else {
        switch (category.displayName) {
          case this.poiDisplayNames.childcare:
            this.activePoi = [this.this.poiCategories.childcare];
            categoryName = this.poiCategories.childcare;
            break;
          case this.poiDisplayNames.health:
            this.activePoi = [this.poiCategories.health];
            categoryName = this.poiCategories.health;
            break;
          case this.poiDisplayNames.education:
            this.activePoi = [this.poiCategories.education];
            categoryName = this.poiCategories.education;
            break;
          case this.poiDisplayNames.transport:
            this.activePoi = [this.poiCategories.transport];
            categoryName = this.poiCategories.transport;
            break;
          case this.poiDisplayNames.outdoor:
            this.activePoi = [this.poiCategories.outdoor];
            categoryName = this.poiCategories.outdoor;
            break;
          case this.poiDisplayNames.food:
            this.activePoi = [this.poiCategories.food];
            categoryName = this.poiCategories.food;
            break;
          case this.poiDisplayNames.shopping:
            this.activePoi = [this.poiCategories.shopping];
            categoryName = this.poiCategories.shopping;
            break;
          case this.poiDisplayNames.professional:
            this.activePoi = [this.poiCategories.professional];
            categoryName = this.poiCategories.professional;
            break;
          default:
            this.activePoi = categoryTypes;
            break;
        }
        this.selectedPoi = category.displayName;
      }
      this.$store.commit("setActiveVenue", null);
      this.$store.commit("setActivePoi", this.activePoi);
      this.$store.commit("zoomToCategory", categoryName);
    },

    selectActiveVenue(venue) {
      this.$store.commit("setActiveVenue", venue);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Places.js